var wpRest;
wpRest = "https://api.solicitapp.com/wp-json/";

// if (process.env.NODE_ENV === "development") {
//   wpRest = "https://api.solicitapp.test:8890/wp-json/"; /* MAMP */
//   wpRest = "https://api.solicitapp.test/wp-json/"; /* DOCKER */
// }

const config = {
  apiURL: wpRest,
  jwtPath: "jwt-auth/v1/",
  sappPath: "sapp/v2/"
};

export default config;
